import React, { Component } from 'react';
import './Calendar.css';
import { connect } from 'react-redux';
import { Tabs, DatePicker } from 'element-react';
import { updateMaxOpeningDate } from '../../services/rooms';
import GCalendar from '../GCalendar/GCalendar';
import { book, cancelBooking, blockPreBooking } from '../../services/bookings';
import { setRooms } from '../../store/actionCreators';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.rooms[0].maxOpeningTimeStamp),
      selectedTab: 1,
    };
  }

  onTabClick = tab => {
    // this.props.rooms[this.state.selectedTab-1].id
    const index = parseInt(tab.props.name);
    this.setState({
      selectedTab: index,
      date: new Date(this.props.rooms[index - 1].maxOpeningTimeStamp),
    });
    console.log(index, tab.props.label, this.props.rooms[index - 1].id);
  }

  async changeDate(date) {
    try {
      await updateMaxOpeningDate(this.props.rooms[this.state.selectedTab - 1].id, date);
      this.setState({ date });

      const rooms = this.props.rooms;
      rooms[this.state.selectedTab - 1].maxOpeningTimeStamp = date;
      this.props.setRooms(rooms);
    } catch (err) {
      console.error(err);
    }
  }

  dayClicked = (date, action, id) => {
    this.setState({ modifying: true });
    return new Promise(async (resolve, reject) => {
      try {
        let tomorrow = new Date(date);
        tomorrow.setDate(tomorrow.getDate() + 1);

        try {
          const data = {
            checkInDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
            checkOutDate: new Date(Date.UTC(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate())),
            state: 1,
            roomId: this.props.rooms[this.state.selectedTab - 1].id,
            totalPaid: 0,
            details: {},
          };

          if (action === 'book') await book(data);
          else if (action === 'cancelBook') await cancelBooking(id);
          else if (action === 'blockPreBooking') await blockPreBooking(id);

          this.setState({ modifying: false });
          resolve(true);
        } catch (err) {
          this.setState({ modifying: false });
          alert('¡Ups! Ha ocurrido un error inesperado, contacta con el proveedor.');
          reject(false);
        }
      } catch (err) {
        this.setState({ modifying: false });
        reject(false);
      }
    });
  }

  render() {
    return (
      <div className="calendarViewWrapper">
        <Tabs type="card" value={this.state.selectedTab.toString()} onTabClick={this.onTabClick}>
          {
            this.props.rooms.map((room, index) => (
              <Tabs.Pane key={index} label={room.name} name={(index + 1).toString()}>
                <div className="calendarWrapper">
                  <h4>Calendari de disponibilitat</h4>
                  <div className="calendarContainer">
                    <div className="calendarLeftContainer">
                      <p>Feu click sobre una data per bloquejar/desbloquejar un dia</p>

                      {
                        index === this.state.selectedTab - 1
                        && <GCalendar
                          roomId={this.props.rooms[this.state.selectedTab - 1].id}
                          date={this.state.date}
                          onDayClicked={this.dayClicked}
                          activeCalendar={this.state.selectedTab}
                        />
                      }

                    </div>
                    <div className="calendarRightContainer">
                      <div className="itemRight">
                        <div className="itemRightLeft"><span className="dot inactive"></span><p>Reservat</p></div>
                        <div className="itemRightLeft"><span className="dot manual"></span><p>Reservat manualment</p></div>
                        <div className="itemRightLeft"><span className="dot active"></span><p>Disponible</p></div>
                        <div className="itemRightLeft"><span className="dot blocked"></span><p>Bloquejat</p></div>
                        <div className="itemRightLeft"><span className="dot noopened"></span><p>No obert</p></div>
                        <div className="itemRightLeft"><span className="dot today"></span><p>Avui</p></div>
                        <div className="itemRightLeft"><span className="dot active prebooked"></span><p>Reserva no efectuada (no pagada - no válida)</p></div>
                      </div>

                      <div className="itemRightRight">
                        <p>Data màxima disponibilitat</p>
                        <DatePicker
                          firstDayOfWeek={1}
                          format="dd-MM-yyyy"
                          value={this.state.date}
                          placeholder="Escull dia"
                          onChange={date => this.changeDate(date)}
                          disabledDate={time => time.getTime() < Date.now() - 8.64e7}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </Tabs.Pane>
            ))
          }

        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rooms: state.rooms
});

export default connect(
  mapStateToProps,
  { setRooms }
)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js